<template v-if="hasTeam">
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <div class="custom-toolbar">
                <div class="custom-toolbar-start">
                    <router-link
                        :to="{
                            name: 'Team Settings'
                        }"
                    >
                        <h3 class="title">Team Settings</h3>
                    </router-link>
                    <h3 class="title">&nbsp;&nbsp; > &nbsp;&nbsp; {{ $t('menus.setting.items') }}</h3>
                </div>
            </div>
        </div>
        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>inventory</md-icon>
                    </div>
                </md-card-header>
                <md-card-content>
                    <h5 class="card-title">
                        Settings
                    </h5>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 layout-item">
                            <div>
                                <md-checkbox v-model="includeItemsInEmailsAndPODDocuments">
                                    Include items in stop status change emails and POD/failed PDF documents
                                </md-checkbox>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-100 layout-item">
                            <div>
                                <md-checkbox v-model="totalItemLoadAsStopLoad">
                                    Stop load quantities total of items
                                </md-checkbox>
                            </div>
                        </div>
                    </div>
                </md-card-content>
                <md-card-actions md-alignment="left">
                    <button class="custom-btn" @click="saveItemSettings">
                        Save
                    </button>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';

export default {
    name: 'ItemSettings',
    mixins: [GeneralMixin],
    computed: {
        ...mapGetters({
            hasTeam: 'user/hasTeam'
        })
    },
    data() {
        return {
            itemConfiguration: null,
            includeItemsInEmailsAndPODDocuments: false,
            totalItemLoadAsStopLoad: false
        };
    },
    async mounted() {
        await this.getTeamData();
    },
    methods: {
        async getTeamData() {
            this.$_handleLoaderState(true);
            const api = '/api/teams';
            const { data } = await handleRequests(api);
            this.$_handleLoaderState(false);

            this.itemConfiguration = data.data.itemConfiguration;

            if (!this.itemConfiguration) {
                this.itemConfiguration = {
                    includeItemsInEmails: false,
                    includeItemsInPODDocuments: false,
                    totalItemLoadAsStopLoad: false
                };
            }

            // Combine the two backend settings into one UI setting
            this.includeItemsInEmailsAndPODDocuments = this.itemConfiguration.includeItemsInEmails === true;
            this.totalItemLoadAsStopLoad = this.itemConfiguration.totalItemLoadAsStopLoad === true;
        },
        async saveItemSettings() {
            // Set the two backend settings from the one UI setting
            this.itemConfiguration.includeItemsInEmails = this.includeItemsInEmailsAndPODDocuments;
            this.itemConfiguration.includeItemsInPODDocuments = this.includeItemsInEmailsAndPODDocuments;
            this.itemConfiguration.totalItemLoadAsStopLoad = this.totalItemLoadAsStopLoad;

            const payload = {
                method: 'put',
                data: this.itemConfiguration
            };
            const api = `/api/teams/settings/itemConfiguration`;

            this.$_handleLoaderState(true, 'SAVING...');
            try {
                await handleRequests(api, payload);
                this.$notifySuccess('Item configuration saved.');
                this.$_handleLoaderState(false);
            } catch (e) {
                const message = 'Cannot save item configuration.';
                showErrorMessage(this, message, e);
                this.$_handleLoaderState(false);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.card-icon {
    background: #ffa726 !important;
}
</style>
